import { injectReducer } from '@/app/store';
import React from 'react';

const withReducer = (key, reducer) => (WrappedComponent) => {
	class WithReducer extends React.PureComponent {
		constructor(props) {
			super(props);
			injectReducer(key, reducer);
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	}

	WithReducer.displayName = `WithReducer(${getDisplayName(WrappedComponent)})`;

	return WithReducer;
};

const getDisplayName = (WrappedComponent) => {
	return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export default withReducer;
